import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import ItemCard from "../components/ItemCard";
import BalanceCard from "../components/BalanceCard";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHouse,
  faWallet,
  faHandHoldingDollar,
  faChartSimple,
  faSackDollar,
  faUserCheck,
  faCircleDollarToSlot,
  faChartLine,
  faGift,
  faFilterCircleDollar,
} from "@fortawesome/free-solid-svg-icons";
import {
  faEye,
  faEyeSlash,
  faFileLines,
} from "@fortawesome/free-regular-svg-icons";
import { Link } from "react-router-dom";
import TradingViewWidget from "../components/TradingViewWidget";
import TradingViewScroll from "../components/TradingViewScroll";
import TradeForm from "../components/TradeForm";
import { useUser } from "../utils/UserContext";
import { useLocation } from "react-router-dom";
import {
  getCurrencySymbol,
  formatCurrency,
  getRate,
} from "../utils/currencyUtils";
import { Toaster, toast } from "react-hot-toast";
import EmailVerifyModal from "../components/EmailVerifyModal";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

function Dashboard1() {
  const { user } = useUser();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const symbol = queryParams.get("symbol");
  const tradetype = queryParams.get("tradetype");
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [rate, setRate] = useState(1);
  const currencyCode = user?.currency;
  useEffect(() => {
    let isMounted = true;
    const fetchRate = async () => {
      const r = await getRate(currencyCode);
      if (isMounted) setRate(r);
    };
    fetchRate();
    return () => {
      isMounted = false;
    };
  }, [currencyCode]);
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [type, setType] = useState(tradetype ? tradetype : "crypto");
  const [trade, setTrade] = useState(
    symbol
      ? symbol
      : type === "crypto"
      ? "BTC"
      : type === "forex"
      ? "AAPL"
      : "EUR"
  );
  const [activeTab, setActiveTab] = useState("open");
  const [see, setSee] = useState(true);
  const [walletTab, setWalletTab] = useState("wallet");
  const [usdbal, setUsdbal] = useState(0);
  const [openTrades, setOpenTrades] = useState([]);
  const [closedTrades, setClosedTrades] = useState([]);
  //WALET CARD
  const [crypto, setCrypto] = useState([]);
  const [fiat, setFiat] = useState([]);
  const [stock, setStock] = useState([]);
  const [wallet, setWallet] = useState([]);
  const [assethistory, setAssethistory] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fetchwallet: true }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setWallet(data.wallet);
        }
      })
      .catch((err) => {
        toast.error("Error fetching deposit transaction!");
      });
  }, [user]);
  useEffect(() => {
    fetch(`/coin_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        var coinList = data.data;
        const updatedData = coinList.map((coin, index) => ({
          id: index + 1,
          logo: `https://s2.coinmarketcap.com/static/img/coins/64x64/${coin.id}.png`,
          name: coin.name,
          type: "crypto",
          symbol: coin.symbol,
          price: Number(coin.quote.USD.price.toFixed(2)),
          amount: 0,
        }));
        setCrypto(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/stock_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const stockList = Object.values(data);
        const updatedData = stockList.map((stock, index) => ({
          id: index + 1,
          logo: `https://images.financialmodelingprep.com/symbol/${stock.symbol}.png`,
          name: stock.name,
          type: "stock",
          symbol: stock.symbol,
          price: Number(stock.price.toFixed(2)),
          amount: 0,
        }));
        setStock(updatedData);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    fetch(`/fiat_list.txt`)
      .then((res) => res.json())
      .then((data) => {
        const wantedCurrencies = {
          AUD: "Australian Dollar",
          CAD: "Canadian Dollar",
          CHF: "Swiss Franc",
          CNY: "Chinese Yuan",
          EUR: "Euro",
          GBP: "British Pound",
          INR: "Indian Rupee",
          JPY: "Japanese Yen",
          RUB: "Russian Ruble",
          USD: "US Dollar",
          ZAR: "South African Rand",
        };
        const fiatList = Object.entries(data)
          .filter(([code]) => wantedCurrencies.hasOwnProperty(code))
          .map(([code, value], index) => ({
            id: index + 1,
            symbol: code,
            name: wantedCurrencies[code],
            price: Number(value),
            type: "fiat",
            logo: `https://flagcdn.com/w40/${code
              .slice(0, 2)
              .toLowerCase()}.png`,
            amount: 0,
          }));

        setFiat(fiatList);
      })
      .catch((err) => console.error("Error loading coin list:", err));
  }, []);
  useEffect(() => {
    if (!crypto.length && !fiat.length && !stock.length) return;
    const walletMap = wallet.reduce((acc, item) => {
      const key = item.coinName?.trim().toLowerCase();
      acc[key] = parseFloat(item.balance) || 0;
      return acc;
    }, {});
    let total = 0;
    const applyWalletBalance = (list) =>
      list.map((item) => {
        const key = item.name?.trim().toLowerCase();
        const matchedBalance = walletMap[key];
        const amount = matchedBalance || 0;
        const value = amount * item.price;
        total += value;
        return {
          ...item,
          amount: matchedBalance || 0,
        };
      });
    const merged = [
      ...applyWalletBalance(crypto),
      ...applyWalletBalance(fiat),
      ...applyWalletBalance(stock),
    ];
    const sorted = merged.sort((a, b) => {
      if (b.amount > 0 && a.amount === 0) return 1;
      if (a.amount > 0 && b.amount === 0) return -1;
      return a.name.localeCompare(b.name);
    });
    setAssethistory(sorted);
    setUsdbal(total);
  }, [crypto, fiat, stock, wallet]);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fetchtrade: true }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          const openTrades = [];
          const closedTrades = [];
          data.trades.forEach((trade) => {
            if (trade.details === "Running") {
              openTrades.push(trade);
            } else {
              closedTrades.push(trade);
            }
          });
          setOpenTrades(openTrades);
          setClosedTrades(closedTrades);
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => {
        toast.error("Error fetching trade data!");
      });
  }, [user]);
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 1273 },
      items: 4,
    },
    desktop: {
      breakpoint: { max: 1273, min: 1024 },
      items: 4,
    },
    tablet: {
      breakpoint: { max: 1000, min: 740 },
      items: 4,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
    },
  };
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <div>
          <Toaster />
        </div>
        <EmailVerifyModal UserDetails={user} />
        <Notification
          isOpen={notificationbar}
          toggleNotification={toggleNotification}
        />
        <Sidebar
          title="Dashboard"
          isOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          toggleSettingsBar={toggleSettingsBar}
          settingsBar={settingsBar}
        />
        <div className="col ps-md-2 mainBar">
          <Header
            title="Dashboard"
            icon={
              <FontAwesomeIcon icon={faHouse} style={{ fontSize: "16px" }} />
            }
            toggleSidebar={toggleSidebar}
            toggleNotification={toggleNotification}
            toggleSettingsBar={toggleSettingsBar}
          />
          <main>
            <div className="row">
              <TradingViewScroll />
              <div className="col-lg-8 col-12">
                <div className="mycard mt-2">
                  <div
                    className="balance-header d-flex flex-column flex-md-row justify-content-between align-items-center p-3 mb-3 rounded-4 shadow-sm"
                    style={{
                      background:
                        "linear-gradient(90deg, #23272f 0%, #18181b 100%)",
                      border: "1px solid #23272f",
                      boxShadow: "0 4px 24px 0 rgba(37,99,235,0.08)",
                    }}
                  >
                    <div className="d-flex align-items-center mb-3 mb-md-0">
                      <div
                        className="balance-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                        style={{
                          background:
                            "linear-gradient(135deg, #2563eb 0%, #60a5fa 100%)",
                          width: "48px",
                          height: "48px",
                          boxShadow: "0 2px 8px 0 rgba(37,99,235,0.12)",
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faWallet}
                          style={{ fontSize: "22px", color: "#fff" }}
                        />
                      </div>
                      <div>
                        <div
                          className="fw-bold mb-0"
                          style={{ fontSize: "1.1rem", color: "#e5e7eb" }}
                        >
                          Total {user?.currency} Balance:
                          <FontAwesomeIcon
                            icon={see ? faEye : faEyeSlash}
                            className="ms-2"
                            style={{
                              fontSize: "16px",
                              cursor: "pointer",
                              color: "#60a5fa",
                            }}
                            onClick={() => setSee(!see)}
                          />
                        </div>
                        <div
                          className="fw-bold"
                          style={{ fontSize: "1.3rem", color: "#fff" }}
                        >
                          {see
                            ? `${getCurrencySymbol(
                                user?.currency
                              )}${formatCurrency(usdbal * rate)}`
                            : "******"}
                        </div>
                      </div>
                    </div>
                    <div className="blockTab-modern d-flex gap-2">
                      <div
                        className={`blockTab-modern-item ${
                          walletTab === "wallet" ? "active" : ""
                        }`}
                        onClick={() => setWalletTab("wallet")}
                        title="Wallet"
                      >
                        <FontAwesomeIcon icon={faWallet} />
                      </div>
                      <div
                        className={`blockTab-modern-item ${
                          walletTab === "accountinfo" ? "active" : ""
                        }`}
                        onClick={() => setWalletTab("accountinfo")}
                        title="Account Info"
                      >
                        <FontAwesomeIcon icon={faSackDollar} />
                      </div>
                      <div
                        className={`blockTab-modern-item ${
                          walletTab === "doc" ? "active" : ""
                        }`}
                        onClick={() => setWalletTab("doc")}
                        title="Documents"
                      >
                        <FontAwesomeIcon icon={faFileLines} />
                      </div>
                    </div>
                  </div>
                  {walletTab === "wallet" && (
                   <div
  className="mb-3 mt-5 top-assets-modern-card p-4 rounded-4 shadow-sm"
  style={{
    border: "none",
    background: "linear-gradient(90deg, #23272f 0%, #18181b 100%)",
    boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.12)",
    width: "100%",
  }}
>
  <div className="d-flex justify-content-between align-items-center mb-4">
    <div className="d-flex align-items-center">
      <div className="top-assets-bar me-3"></div>
      <p className="mb-0 fw-bold text-white fs-5">Top Assets</p>
    </div>
    <Link
      to="/assets"
      className="fw-bold text-decoration-none text-prime"
      style={{ fontSize: "15px" }}
    >
      View all assets
    </Link>
  </div>
  {assethistory.map(
    (asset) =>
      asset.symbol === "BTC" && (
        <ItemCard
          icon={
            <img
              src={asset.logo}
              alt={asset.name}
              style={{
                width: "32px",
                borderRadius: "50%",
                background: "#fff",
                padding: "4px",
                boxShadow: "0 2px 8px 0 rgba(37,99,235,0.10)",
              }}
            />
          }
          name={asset.name}
          symbol={asset.symbol}
          bal={asset.amount}
          balusd={formatCurrency(asset.price * asset.amount * rate)}
          currency={getCurrencySymbol(user?.currency)}
        />
      )
  )}
  {assethistory.map(
    (asset) =>
      asset.symbol === "ETH" && (
        <ItemCard
          icon={
            <img
              src={asset.logo}
              alt={asset.name}
              style={{
                width: "32px",
                borderRadius: "50%",
                background: "#fff",
                padding: "4px",
                boxShadow: "0 2px 8px 0 rgba(37,99,235,0.10)",
              }}
            />
          }
          name={asset.name}
          symbol={asset.symbol}
          bal={asset.amount}
          balusd={formatCurrency(asset.price * asset.amount * rate)}
          currency={getCurrencySymbol(user?.currency)}
        />
      )
  )}
  {assethistory.map(
    (asset) =>
      asset.symbol === "SOL" && (
        <ItemCard
          icon={
            <img
              src={asset.logo}
              alt={asset.name}
              style={{
                width: "32px",
                borderRadius: "50%",
                background: "#fff",
                padding: "4px",
                boxShadow: "0 2px 8px 0 rgba(37,99,235,0.10)",
              }}
            />
          }
          name={asset.name}
          symbol={asset.symbol}
          bal={asset.amount}
          balusd={formatCurrency(asset.price * asset.amount * rate)}
          currency={getCurrencySymbol(user?.currency)}
        />
      )
  )}
  {assethistory.map(
    (asset) =>
      asset.symbol === "XRP" && (
        <ItemCard
          icon={
            <img
              src={asset.logo}
              alt={asset.name}
              style={{
                width: "32px",
                borderRadius: "50%",
                background: "#fff",
                padding: "4px",
                boxShadow: "0 2px 8px 0 rgba(37,99,235,0.10)",
              }}
            />
          }
          name={asset.name}
          symbol={asset.symbol}
          bal={asset.amount}
          balusd={formatCurrency(asset.price * asset.amount * rate)}
          currency={getCurrencySymbol(user?.currency)}
        />
      )
  )}
  {assethistory.map(
    (asset) =>
      asset.symbol === "XLM" && (
        <ItemCard
          icon={
            <img
              src={asset.logo}
              alt={asset.name}
              style={{
                width: "32px",
                borderRadius: "50%",
                background: "#fff",
                padding: "4px",
                boxShadow: "0 2px 8px 0 rgba(37,99,235,0.10)",
              }}
            />
          }
          name={asset.name}
          symbol={asset.symbol}
          bal={asset.amount}
          balusd={formatCurrency(asset.price * asset.amount * rate)}
          currency={getCurrencySymbol(user?.currency)}
        />
      )
  )}
  {assethistory.map(
    (asset) =>
      asset.symbol === "USD" && (
        <ItemCard
          icon={
            <img
              src={asset.logo}
              alt={asset.name}
              style={{
                width: "32px",
                borderRadius: "50%",
                background: "#fff",
                padding: "4px",
                boxShadow: "0 2px 8px 0 rgba(37,99,235,0.10)",
              }}
            />
          }
          name={asset.name}
          symbol={asset.symbol}
          bal={asset.amount}
          balusd={formatCurrency(asset.price * asset.amount * rate)}
          currency={getCurrencySymbol(user?.currency)}
        />
      )
  )}
  {assethistory.map(
    (asset) =>
      asset.symbol === "AAPL" && (
        <ItemCard
          icon={
            <img
              src={asset.logo}
              alt={asset.name}
              style={{
                width: "32px",
                borderRadius: "50%",
                background: "#fff",
                padding: "4px",
                boxShadow: "0 2px 8px 0 rgba(37,99,235,0.10)",
              }}
            />
          }
          name={asset.name}
          symbol={asset.symbol}
          bal={asset.amount}
          balusd={formatCurrency(asset.price * asset.amount * rate)}
          currency={getCurrencySymbol(user?.currency)}
        />
      )
  )}
</div>
                  )}
                  {walletTab === "accountinfo" && (
                    <div className="row">
                      <div className="col-xxl-4 col-lg-6 g-5">
                        <BalanceCard
                          name="Last Profit"
                          amount={`${getCurrencySymbol(
                            user?.currency
                          )}${formatCurrency(user?.last_profit * rate)}`}
                          icon={
                            <FontAwesomeIcon
                              icon={faCircleDollarToSlot}
                              className="text-white fs-4"
                            />
                          }
                        />
                      </div>
                      <div className="col-xxl-4 col-lg-6 g-5">
                        <BalanceCard
                          name="Total Trades"
                          amount={`${getCurrencySymbol(
                            user?.currency
                          )}${formatCurrency(user?.total_trade * rate)}`}
                          icon={
                            <FontAwesomeIcon
                              icon={faChartLine}
                              className="text-white fs-4"
                            />
                          }
                        />
                      </div>
                      <div className="col-xxl-4 col-lg-6 g-5">
                        <BalanceCard
                          name="Free Airdrops"
                          amount={`${getCurrencySymbol(
                            user?.currency
                          )}${formatCurrency(user?.bonus * rate)}`}
                          icon={
                            <FontAwesomeIcon
                              icon={faGift}
                              className="text-white fs-4"
                            />
                          }
                        />
                      </div>
                      <div className="col-xxl-4 col-lg-6 g-5">
                        <BalanceCard
                          name="Total Won"
                          amount={`${getCurrencySymbol(
                            user?.currency
                          )}${formatCurrency(user?.total_won * rate)}`}
                          icon={
                            <FontAwesomeIcon
                              icon={faFilterCircleDollar}
                              className="text-white fs-4"
                            />
                          }
                        />
                      </div>
                      <div className="col-xxl-4 col-lg-6 g-5">
                        <BalanceCard
                          name="Total Loss"
                          amount={`${getCurrencySymbol(
                            user?.currency
                          )}${formatCurrency(user?.total_loss * rate)}`}
                          icon={
                            <FontAwesomeIcon
                              icon={faFilterCircleDollar}
                              className="text-white fs-4"
                            />
                          }
                        />
                      </div>
                    </div>
                  )}
                  {walletTab === "doc" && (
                    <div className="mb-3 mt-5">
                      <p className="mb-0 fw-bold text-white mb-3">
                        Account Summary
                      </p>
                      <div className="itemcard py-3">
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon
                            icon={faHandHoldingDollar}
                            className="text-secondary"
                          />
                          <h6
                            className="mb-0 fw-bold text-white ms-2"
                            style={{ fontSize: "15px" }}
                          >
                            Total Deposits
                          </h6>
                        </div>
                        <h6
                          className="mb-0 fw-bold text-white"
                          style={{ fontSize: "15px" }}
                        >
                          {getCurrencySymbol(user?.currency)}
                          {formatCurrency(user?.total_deposit * rate)}
                        </h6>
                        <Link to="/deposit" className="myBtn d-none d-md-block">
                          Deposit
                        </Link>
                      </div>
                      <div className="itemcard py-3">
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon
                            icon={faSackDollar}
                            className="text-secondary"
                          />
                          <h6
                            className="mb-0 fw-bold text-white ms-2"
                            style={{ fontSize: "15px" }}
                          >
                            Total Withdrawals
                          </h6>
                        </div>
                        <h6
                          className="mb-0 fw-bold text-white"
                          style={{ fontSize: "15px" }}
                        >
                          {getCurrencySymbol(user?.currency)}
                          {formatCurrency(user?.total_withdraw * rate)}
                        </h6>
                        <Link
                          to="/withdraw"
                          className="myBtn d-none d-md-block"
                        >
                          Withdraw
                        </Link>
                      </div>
                      <div className="itemcard py-3">
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon
                            icon={faChartSimple}
                            className="text-secondary"
                          />
                          <h6
                            className="mb-0 fw-bold text-white ms-2"
                            style={{ fontSize: "15px" }}
                          >
                            Total Profits
                          </h6>
                        </div>
                        <h6
                          className="mb-0 fw-bold text-white"
                          style={{ fontSize: "15px" }}
                        >
                          {getCurrencySymbol(user?.currency)}
                          {formatCurrency(user?.profit * rate)}
                        </h6>
                        <div
                          style={{ width: "80px" }}
                          className="d-none d-md-block"
                        ></div>
                      </div>
                      <div className="itemcard py-3">
                        <div className="d-flex align-items-center">
                          <FontAwesomeIcon
                            icon={faUserCheck}
                            className="text-secondary"
                          />
                          <h6
                            className="mb-0 fw-bold text-white ms-2"
                            style={{ fontSize: "15px" }}
                          >
                            Verification
                          </h6>
                        </div>
                        <p
                          className={`mb-0 text-${
                            user?.verify == 1 ? "success" : "danger"
                          } text-decoration-none`}
                          style={{ fontSize: "15px" }}
                        >
                          {user?.verify == 1
                            ? "Your account is verified"
                            : "Your account is not verified"}
                        </p>
                        <div className="d-none d-md-block"></div>
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="mt-2 d-flex flex-column align-items-center"
                  style={{ maxWidth: "100%" }}
                >
                  <h5 className="fw-bold mt-4">Investments made easy</h5>
                  <p style={{ fontSize: "14px" }}>
                    Buy stocks with as little as{" "}
                    {getCurrencySymbol(user?.currency)}1
                  </p>
                  <Link
                    to="/Stock"
                    className="myBtn bg-prime fw-bold rounded-0 py-3 text-center"
                    style={{ maxWidth: "400px", width: "100%" }}
                  >
                    Explore Stocks
                  </Link>
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <div className="mycard mt-2">
                  <h6 className="text-secondary fw-bold mb-2">Categories</h6>
                  <p className="text-white fs-7">
                    No categories yet.{" "}
                    <Link
                      to="/deposit"
                      className="text-decoration-none text-prime"
                    >
                      Deposit now
                    </Link>{" "}
                    to see your portfolio breakdown.
                  </p>
                  <div
                    className="d-flex align-items-center justify-content-between mb-4"
                    style={{ marginTop: "200px" }}
                  >
                    <h6 className="text-secondary fw-bold mb-0">
                      Trading progress
                    </h6>
                    <h6 className="text-white fw-bold mb-0">
                      {user?.trade_progress}%
                    </h6>
                  </div>
                  <div
                    className="progress"
                    style={{
                      height: "12px",
                      backgroundColor: "rgba(78, 190, 150, 0.5)",
                      marginBottom: "44px",
                    }}
                  >
                    <div
                      className="progress-bar bg-success"
                      style={{
                        width: `${user?.trade_progress}%`,
                        backgroundColor: "rgb(78, 190, 150)",
                      }}
                    ></div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <h6 className="text-secondary fw-bold mb-0">
                      Signal strength
                    </h6>
                    <h6
                      className={`fw-bold mb-0 ${
                        user?.signals > 70
                          ? "text-success"
                          : user?.signals > 30
                          ? "text-warning"
                          : "text-danger"
                      }`}
                    >
                      {user?.signals}%
                    </h6>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    {Array(20)
                      .fill()
                      .map((_, i) => {
                        const isActive = i < user?.signals / 5;
                        let activeColor, inactiveColor;
                        if (user?.signals > 70) {
                          activeColor = "rgb(40, 167, 69)"; // Green
                          inactiveColor = "rgba(40, 167, 69, 0.5)";
                        } else if (user?.signals > 30) {
                          activeColor = "rgb(255, 193, 7)"; // Yellow
                          inactiveColor = "rgba(255, 193, 7, 0.5)";
                        } else {
                          activeColor = "rgb(255, 51, 68)"; // Red
                          inactiveColor = "rgba(255, 51, 68, 0.5)";
                        }
                        return (
                          <div
                            key={i}
                            style={{
                              width: "4%",
                              height: "12px",
                              borderRadius: "2px",
                              backgroundColor: isActive
                                ? activeColor
                                : inactiveColor,
                              transition: "background-color 0.3s ease-in-out",
                            }}
                          ></div>
                        );
                      })}
                  </div>
                </div>
                      
                <div
                  className="carousel-container mt-5"
                  style={{ maxWidth: "1100px" }}
                >
                  <Carousel
                    responsive={responsive}
                    swipeable={true}
                    draggable={true}
                    showDots={false}
                    ssr={true}
                    infinite={true}
                    autoPlay={true}
                    keyBoardControl={true}
                    containerClass="carousel-container"
                    removeArrowOnDeviceType={["tablet", "mobile", "desktop"]}
                  >
                    {stock.map((stocklist) => {
                      const randomChart = [
                        "redchart.png",
                        "yellowchart.png",
                        "bluechart.png",
                        "graychart.png",
                      ][Math.floor(Math.random() * 4)];
                      return (
                        <div
                          key={stocklist.id}
                          className="mycard d-flex align-item   s-center flex-column p-0 me-2 me-lg-3"
                          style={{ backgroundColor: "#ffffff1c" }}
                        >
                          <img
                            src={stocklist.logo}
                            alt={stocklist.name}
                            style={{ width: "30px" }}
                            className="mt-3 mb-4"
                          />
                          <img
                            src={require(`../images/${randomChart}`)}
                            alt="chart"
                            style={{ height: "42px" }}
                            className="w-100 mb-2"
                          />
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
              </div>

              <div className="col-lg-8 col-12">
                <div className="mycard p-2 mt-2">
                  <TradingViewWidget symbol={trade} type={type} />
                </div>
              </div>
              <div className="col-lg-4 col-12">
                <TradeForm
                  trade={trade}
                  setTrade={setTrade}
                  type={type}
                  setType={setType}
                />
              </div>
              <div className="col-12">
                <div className="mycard mt-2" style={{ minHeight: "450px" }}>
                  <div className="d-flex align-items-center mb-4">
                    <h6
                      className="mb-0 text-white me-3"
                      style={{ fontSize: "18px" }}
                    >
                      Trades
                    </h6>
                    <div className="mytab">
                      <div
                        className={`mytab-item ${
                          activeTab === "open" ? "active" : ""
                        }`}
                        onClick={() => {
                          setActiveTab("open");
                        }}
                      >
                        Open
                      </div>
                      <div
                        className={`mytab-item ${
                          activeTab !== "open" ? "active" : ""
                        }`}
                        onClick={() => {
                          setActiveTab("closed");
                        }}
                      >
                        Closed
                      </div>
                    </div>
                  </div>
                  <div className="table-responsive">
                    {activeTab === "open" && (
                      <table className="table table-borderless table-dark align-middle">
                        <thead>
                          <tr className="fs-7">
                            <th
                              className="fw-normal text-light"
                              style={{ width: "150px" }}
                            >
                              Trade ID
                            </th>
                            <th
                              className="fw-normal text-light"
                              style={{ width: "150px" }}
                            >
                              Date
                            </th>
                            <th className="fw-normal text-light">Type</th>
                            <th className="fw-normal text-light">Trade</th>
                            <th className="fw-normal text-light">Direction</th>
                            <th className="fw-normal text-light">Amount</th>
                            <th className="fw-normal text-light text-nowrap">
                              Entry Price
                            </th>
                            <th className="fw-normal text-light text-nowrap">
                              Stop Loss
                            </th>
                            <th className="fw-normal text-light text-nowrap">
                              Take Profit
                            </th>
                            <th className="fw-normal text-light text-nowrap">
                              Time Frame
                            </th>
                            <th className="fw-normal text-light text-nowrap">
                              Leverage
                            </th>
                            <th className="fw-normal text-light">Profit</th>
                            <th className="fw-normal text-light">Action</th>
                          </tr>
                        </thead>
                        <tbody style={{ fontSize: "14px" }}>
                          {openTrades.length > 0 &&
                            openTrades.map((trade, index) => (
                              <tr key={index}>
                                <td>{trade.trade_id}</td>
                                <td>{trade.trade_time}</td>
                                <td>{trade.type}</td>
                                <td>{trade.pair}</td>
                                <td>{trade.action}</td>
                                <td>{trade.amount}</td>
                                <td>{trade.entry}</td>
                                <td>{trade.sl}</td>
                                <td>{trade.tp}</td>
                                <td>{trade.tf}</td>
                                <td>{trade.leverage}X</td>
                                <td>{trade.result}</td>
                                <td className="text-warning">
                                  {trade.details}
                                </td>
                              </tr>
                            ))}
                          {openTrades.length === 0 && (
                            <tr>
                              <td colSpan={5}>No Open trades yet.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                    {activeTab === "closed" && (
                      <table className="table table-borderless table-dark align-middle">
                        <thead>
                          <tr className="fs-7">
                            <th
                              className="fw-normal text-light"
                              style={{ width: "150px" }}
                            >
                              Trade ID
                            </th>
                            <th
                              className="fw-normal text-light"
                              style={{ width: "150px" }}
                            >
                              Date
                            </th>
                            <th className="fw-normal text-light">Type</th>
                            <th className="fw-normal text-light">Trade</th>
                            <th className="fw-normal text-light">Direction</th>
                            <th className="fw-normal text-light">Amount</th>
                            <th className="fw-normal text-light text-nowrap">
                              Entry Price
                            </th>
                            <th className="fw-normal text-light text-nowrap">
                              Stop Loss
                            </th>
                            <th className="fw-normal text-light text-nowrap">
                              Take Profit
                            </th>
                            <th className="fw-normal text-light text-nowrap">
                              Time Frame
                            </th>
                            <th className="fw-normal text-light text-nowrap">
                              Leverage
                            </th>
                            <th className="fw-normal text-light">Profit</th>
                            <th className="fw-normal text-light">Action</th>
                          </tr>
                        </thead>
                        <tbody style={{ fontSize: "14px" }}>
                          {closedTrades.length > 0 &&
                            closedTrades.map((trade, index) => (
                              <tr key={index}>
                                <td>{trade.trade_id}</td>
                                <td>{trade.trade_time}</td>
                                <td>{trade.type}</td>
                                <td>{trade.pair}</td>
                                <td>{trade.action}</td>
                                <td>{trade.amount}</td>
                                <td>{trade.entry}</td>
                                <td>{trade.sl}</td>
                                <td>{trade.tp}</td>
                                <td>{trade.tf}</td>
                                <td>{trade.leverage}X</td>
                                <td>{trade.result}</td>
                                <td
                                  className={`${
                                    trade.details === "Loss"
                                      ? "text-danger"
                                      : "text-success"
                                  }`}
                                >
                                  {trade.details}
                                </td>
                              </tr>
                            ))}
                          {closedTrades.length === 0 && (
                            <tr>
                              <td colSpan={5}>No Closed trades yet.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}

export default Dashboard1;
